<div>
    <button *ngIf="!navBoolean" (click)="animar()" class="btn btn-nav">
        <i class="fas fa-bars fa-3x"></i>
    </button>
    <button *ngIf="navBoolean" (click)="animar()" class="btn btn-nav">
        <i class="fas fa-times fa-3x"></i>
    </button>
    <nav id="nav" class="container-nav ocultarNav">
        <div class="container-fluid">
            <div class="row">
                <div class="col-xs col-lg-6 container-links">
                    <div class="row">
                        <div id="div1" class="col-6 container-a-1 ocultarElementoNav">
                            <a [routerLink]="['/proyectos']" routerLinkActive="router-link-active" ><h1 class="navH1">Proyectos</h1></a>
                        </div>
                        <div id="div2" class="col-6 container-a-2 ocultarElementoNav">
                            <a [routerLink]="['/aboutMe']" routerLinkActive="router-link-active" ><h1 class="navH1">Sobre mi</h1></a>
                        </div>
                        <div id="div3" class="col-6 container-a-2 ocultarElementoNavAbajo">
                            <a [routerLink]="['/habilidades']" routerLinkActive="router-link-active" ><h1 class="navH1">Habilidades</h1></a>
                        </div>
                        <div id="div4" class="col-6 container-a-1 ocultarElementoNavAbajo">
                            <a [routerLink]="['/blog']" routerLinkActive="router-link-active" ><h1 class="navH1">Blog</h1></a>
                        </div>
                    </div>
                </div>
                <div class="col-xs col-lg-6 container-nav-tarjeta ocultarTarjeta" id="divTarjeta">
                    <app-tarjeta></app-tarjeta>
                </div>
            </div>
        </div>
    </nav>
    <div class="container-home">
        <app-tarjeta></app-tarjeta>
    </div>
</div>